import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { ManageServicePathName } from '@/modules/ta/manageservice/manageservice.constants';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: '/sup/service/manage',
      alias: RouteGroup.CONNECT_DATA,
      name: ManageServicePathName.SUP_MANAGE_SERVICE,
      component: () =>
        import(
          /* webpackChunkName: "sup-servicemanage-page" */ '@/modules/ta/manageservice/pages/ManageServicePage'
        ),
    },
    {
      path: '/sup/service/manage/connections/:id',
      name: ManageServicePathName.SUP_MANAGE_CONNECTIONS,
      component: () =>
        import(
          /* webpackChunkName: "test-servicemanage-page" */ '@/modules/ta/manageservice/pages/ManageServicePage'
        ),
    },
    {
      path: '/connectdata/connections/:id',
      redirect: (to) => `/sup/service/manage/connections/${to.params.id}`,
    },
    {
      path: '/sup/service/manage/connection',
      name: ManageServicePathName.SUP_SERVICE_MANAGE_CONNECTION,
      component: () =>
        import(
          /* webpackChunkName: "sup-servicemanageconnection-page" */ '@/modules/ta/manageservice/pages/ManageConnectionPage'
        ),
    },
    {
      path: '/connectdata/connection',
      redirect: '/sup/service/manage/connection',
    },
    {
      path: '/sup/service/manage/:id',
      name: ManageServicePathName.SUP_MANAGE_SERVICE_ACCOUNTS,
      component: () =>
        import(
          /* webpackChunkName: "serviceassignment-page" */ '@/modules/ta/manageservice/pages/ManageServiceAccountsPage'
        ),
    },
    {
      path: '/connectdata/:id',
      redirect: (to) => `/sup/service/manage/${to.params.id}`,
    },
    /**
     * Redirect the test routes for new MDS to the proper ones
     */
    {
      path: '/test/service/manage',
      redirect: '/sup/service/manage',
    },
    {
      path: '/test/service/manage/connection',
      redirect: '/sup/service/manage/connection',
    },
    {
      path: '/test/service/manage/:id',
      redirect: '/sup/service/manage/:id',
    },
  ],
  Module.SERVICE
);
